export const environment = {
  production: true,
  BASE_URL:'https://dev.contractor.controlfms.com/',
  encrypt_passcode : '6478'
};
